import {
  Grid,
  Typography,
  withStyles,
  Theme,
  Box,
  FormControlLabel,
  Checkbox,
  Button
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
// import fileDownload from 'js-file-download'
// import BulbOutlineIcon from 'mdi-react/BulbOutlineIcon'
import CancelIcon from 'mdi-react/CancelCircleOutlineIcon'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
// import DownloadIcon from 'mdi-react/DownloadIcon'

import { useEffect, useState, useCallback, useLayoutEffect } from 'react'
import { withTranslation, WithTranslation, Trans } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { Dispatch } from 'redux'
import { reduxForm, change, Field, formValueSelector } from 'redux-form'
import { stepInstantRentForward } from '../../actions/apartments'
import ConfirmationDialogRaw from '../../components/ConfirmationDialogRaw/ConfirmationDialog'
import {
  ReduxCheckbox,
  ReduxFormField
} from '../../components/FormInput/ReduxWrappers'
import ReduxPicker from '../../components/FormInput/ReduxWrappers/ReduxPicker'
import LoadingContainer from '../../components/LoadingContainer/LoadingContainer'
import DownloadIcon from '../../images/Download.svg'
import OutlineLockPersonIcon from '../../images/ic_outline-lock-person.svg'
import RentalDepositAsset from '../../images/RentalDepositAsset.svg'
import suggestIcon from '../../images/suggest.svg'
import WarningIcon from '../../images/warning.svg'
import { charsSpace, onlyNums } from '../../libs/normalize/information'
import Api from '../../services/applications'
import i18n from '../../translations/i18n'
import { MuiClasses } from '../../types'
import { ApartmentInformation, DropDownItem } from '../../types/apartments'
import { AutocompleteOption } from '../../types/autocomplete'
import { ReduxForm } from '../../types/forms'
import { WaterFeeBasis } from '../../types/propValues/apartments'
import { StateInterface } from '../../types/states'
import {
  isInvalidCharacters,
  isPostalCode,
  lessThanAvailableUntil,
  noSpacesPhoneNum,
  noSpaceValue,
  required,
  requiredLocation,
  validateEmail,
  validatePhoneNumber
} from '../../utils/validation/forms'
import Dialog from '../Dialog'
import { MyInput, ReduxFormSelect } from '../NewApplication/Fields'
import { BackButton } from './BackButton'
import InstantRentCompletePage from './InnerPages/InstantRentCompletePage'
import InstantRentPrompt from './InnerPages/InstantRentPrompt'
import TerminationOfTenancyModal from './Modals/TerminationOfTenancyModal'
import NextStepButton from './NextStepButton'
import StartAuthTrigger from './StartAuthTrigger'
import Suggest from './Steps/Suggest'
const styles = ({ breakpoints, typography }: Theme) => ({
  formContainer: {
    // padding: '35px 0 15px 0',
    // maxWidth: '550px',
    maxWidth: '1131px',
    width: '80%',
    margin: 'auto',
    padding: '3.5rem 0',
    [breakpoints.down('sm')]: {
      width: '100%',
      margin: '0 auto 10em',
      padding: '0.5rem 0 3.5rem'
    }
  },
  modalMobile: {
    [breakpoints.down('sm')]: {
      margin: '20px'
    }
  },
  paymentOption: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    flexWrap: 'wrap',
    marginTop: '30px'
  } as const,
  paymentCard: {
    // width: '23% '
  },
  buttons: {
    margin: '2rem 0 2rem 0',
    width: '100%',
    [breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: 0,
      margin: 0,
      backgroundColor: '#fff',
      padding: '10px'
    }
  },
  button: {
    // width: '48%',
    [breakpoints.down('sm')]: {
      borderRadius: 0
    }
  },
  buttonGridContainer: {
    width: '47.5%'
  },
  cancelTextButton: {
    color: '#D43838',
    fontSize: '1.375rem',
    height: '65px',
    textTransform: 'none' as const,
    background: 'none',
    boxShadow: 'none',
    fontWeight: 'bold' as const,
    backgroundColor: '#fff',
    '&:hover': {
      background: 'none',
      boxShadow: 'none'
    },
    [breakpoints.down('sm')]: {
      // marginBottom: '100px'
    }
  },
  responsiveWidth: {
    [breakpoints.down('sm')]: {
      padding: '0 2rem'
    }
  },
  leaseContainer: {
    marginTop: '4rem',
    marginBottom: '4.5rem',
    [breakpoints.down('sm')]: {
      marginTop: '3.2rem',
      marginBottom: '2.25rem'
    }
  },
  moversSection: {
    marginTop: '3.6rem',
    [breakpoints.down('sm')]: {
      marginTop: '2rem'
    }
  },
  moversContainer: {
    padding: '40px 30px 47px 41px',
    borderRadius: '20px',
    [breakpoints.down('sm')]: {
      padding: '32px 30px 43px 30px'
    }
  },
  leaseDurationTitle: {
    marginBottom: '2rem',
    [breakpoints.down('sm')]: {
      marginBottom: '1.625rem'
    }
  },
  moversTitle: {
    marginBottom: '1.6rem',
    [breakpoints.down('sm')]: {
      marginBottom: '1.875rem'
    }
  },
  moversField: {
    margin: '1.4rem auto 1.2rem auto',
    '& .react-select__control': {
      padding: '2px 8px',
      borderRadius: '8px'
    },
    '& .react-select__placeholder': {
      fontSize: '16px'
    },
    [breakpoints.down('sm')]: {
      margin: '1.8rem auto 1.625rem auto'
    }
  },
  inlineDatePicker: {
    // border: '2px solid red',
    borderRadius: '8px'
  },
  labelText: {
    fontSize: typography.pxToRem(18)
  },
  formLabel: {
    fontSize: typography.pxToRem(20),
    [breakpoints.down('sm')]: {
      fontSize: typography.pxToRem(16),
      marginBottom: '8px'
    }
  },
  calendarInputContainer: {
    padding: '25px 32px 29px 32px',
    [breakpoints.down('sm')]: {
      // padding: '36px 16px 37px 42px'
      padding: '36px 25px 37px 25px;',
      marginBottom: '20px'
    }
  },
  containerStyle: {
    marginLeft: '30px',
    [breakpoints.down('sm')]: {
      marginLeft: '0px'
    }
  },
  sartDateRow: {
    height: '178px',
    alignItems: 'center',
    [breakpoints.down('sm')]: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  },
  stepTwoInfo: {
    '> div': {
      display: 'flex'
    },
    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  stepTwoInfoDetails: {
    display: 'flex',
    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  dialogContanier: {
    paddingTop: '3.875rem',
    paddingBottom: '3.875rem'
  },
  authPrompt: {
    padding: '54px 0',
    marginTop: '55px',
    [breakpoints.down('sm')]: {
      padding: '84px 0'
    }
  },
  applicantInfo: {
    // padding: '54px 0',
    marginTop: '51px',
    [breakpoints.down('sm')]: {
      padding: '2rem 0',
      marginBottom: '7rem'
    }
  },
  authDesc: {
    marginTop: '2rem',
    marginBottom: '3.375rem'
  },
  requiredField: {
    '&:after': {
      content: '"*"',
      color: 'red'
    }
  },
  labelChecker: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '10px 0',
    [breakpoints.down('sm')]: {
      padding: '15px',
      paddingLeft: '2em',
      paddingRight: '1em',
      marginRight: '0'
    }
  },
  heading: {
    [breakpoints.down('sm')]: {
      fontSize: '1.1rem'
    }
  },
  mBottom: {
    marginBottom: '10px'
  },
  suggestIcon: {
    objectFit: 'contain',
    width: '30px',
    [breakpoints.down('sm')]: {
      marginBottom: '10px'
    }
  } as const,
  paragraphStyle: {
    fontSize: '1.1rem',
    '& span': {
      color: '#4F9B44'
    },
    [breakpoints.down('sm')]: {
      marginRight: '10px',
      marginLeft: '20px'
    }
  },
  modalSecondaryButton: {
    marginTop: '20px'
  }
})

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 560,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    width: '90%',
    borderRadius: 35
  }
}))

interface InstantRentFormProps
  extends WithTranslation,
    ReduxForm,
    ApartmentInformation {
  autocompleteLocation: undefined | AutocompleteOption | string
  saveInstantRentForm: (arg: any) => any
  isDisabled: boolean
  classes: MuiClasses
  t: i18n.TFunction
  changeFormValue: (field: string, value: string) => void
  currentStep: any
  doStepBack: () => void
  isMobile: any
  waterFeeBasis: WaterFeeBasis | undefined
  beforeLogin?: boolean
  doNextStep: any
  readyForMoveDate: any
  movingWithAmount: number | DropDownItem
  acceptedTc: boolean
  contactEmail: string
  phoneNumber: string
  postalCode: string
  postalArea: string
}
const InstantRentForm = ({
  classes,
  t,
  handleSubmit,
  submitting,
  saveInstantRentForm,
  doStepBack,
  movingWithAmount,
  readyForMoveDate,
  acceptedTc,
  currentStep,
  isMobile,
  beforeLogin,
  isDisabled,
  doNextStep,
  contactEmail,
  phoneNumber,
  autocompleteLocation,
  postalCode,
  postalArea
}: InstantRentFormProps) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const routeMatch = useRouteMatch()
  const apartmentCode = (routeMatch.params as any).apartmentCode
  const location = useLocation()

  //validation
  useEffect(() => {
    if (
      [4, 5, 6, 7, 8].includes(currentStep) &&
      !localStorage.getItem('application')
    ) {
      history.push(`/instant-rent/${apartmentCode}/steps/1`)
    }
  })

  useEffect(() => {
    if (localStorage.getItem('authInfo') !== undefined) {
      const { language, movingWithAmount, readyForMoveDate } = JSON.parse(
        localStorage.getItem('authInfo') || '[]'
      )
      dispatch(change('InstantRentForm', 'movingWithAmount', movingWithAmount))
      dispatch(change('InstantRentForm', 'readyForMoveDate', readyForMoveDate))
      dispatch(change('InstantRentForm', 'apartmentCode', apartmentCode))
      dispatch(change('InstantRentForm', 'language', language))
    }
  }, [])

  const [isEmpty, setIsEmpty] = useState(false)
  // const [checkStepOnw, setCheckStepOnw] = useState(true)
  //const [appResponse, setAppResponse] = useState(null) as any
  const [applicantCreditStatus, setApplicantCreditStatus] = useState(false)
  const [authenticationError, setAuthenticationError] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [newRentDialog, setNewRentDialog] = useState(null) as any
  const [rentedDialog, setRentedDialog] = useState(null) as any
  const [open, setOpen] = useState(true)
  const [acceptDraftCheck, setAcceptDraftCheck] = useState(false)
  const [isTour, setTour] = useState(false)
  const [isPaymentStatus, setPaymentStatus] = useState(null) as any
  const [failedPaymentModal, setFailedPaymentModal] = useState(true)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  // isApartment,
  // const [setApartment] = useState(null) as any

  const dialogClasses = useStyles()
  const url = new URL(window.location.href)

  const navigateTo = useCallback(
    (newStep) => {
      history.push(`/instant-rent/${apartmentCode}/steps/${newStep}`)
    },
    [history, routeMatch]
  )

  const setStorageItem = (applicaiton: any, name = 'application') => {
    localStorage.setItem(name, JSON.stringify(applicaiton))
  }

  const getStorageItem = (name = 'application'): any => {
    return JSON.parse(localStorage.getItem(name) || '{}')
  }

  const validateApplicantAuthedWithGoodCredit = async () => {
    const code = url.searchParams.get('code')
    const status = url.searchParams.get('status')
    if (!code && !status) {
      return
    }

    if (status !== 'success') {
      setAuthenticationError(true)
      return
    }

    setLoading(true)

    await Api.getApplicationByCode(`${code}`)
      .then((response) => {
        //setAppResponse(response)
        setStorageItem(response)
        if (response?.metadata.hasGoodCredit === false) {
          setApplicantCreditStatus(true)
          setLoading(false)
        } else {
          navigateTo(4)
          setApplicantCreditStatus(false)
          setLoading(false)
        }
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      })
  }

  //restart application
  const handleRestartApplication = () => {
    setOpen(false)
    localStorage.clear()
    navigateTo(1)
  }

  // Add new Tenant
  const addNewTenant = () => {
    setOpen(false)
    navigateTo(3)
  }

  // try payment again
  const tryAgainHandler = () => {
    setFailedPaymentModal(false)
    setAuthenticationError(false)
  }

  const cancelApplication = () => {
    localStorage.clear()
    window.location.href = 'https://fiksuvuokraus.fi/'
  }

  const handleFormEvent = () => {
    if (
      contactEmail &&
      phoneNumber &&
      autocompleteLocation &&
      postalCode &&
      postalArea
    ) {
      setIsEmpty(false)
      setLoading(true)

      const { code = '', ...application } = getStorageItem()

      console.log(application)

      //applicants status=created before updateInfo (step4)
      const applicant = application?.applicants.find(
        (x: { status: string }) => x.status === 'created'
      )

      console.log(applicant)

      Api.updateInstantRent({
        applicationCode: code,
        applicantCode: applicant?.code,
        email: contactEmail,
        phone: phoneNumber,
        address: autocompleteLocation,
        postalCode: postalCode,
        postalArea: postalArea
      })
        .then((response) => {
          setStorageItem(response)
          setNewRentDialog(response)
          setLoading(false)
          //navigateTo(5)
        })
        .catch((error) => {
          console.log('error', error.response)
          setLoading(false)
        })
    } else {
      setIsEmpty(true)
      setLoading(false)
    }
  }

  //  Download PDF
  const generateTenantPDF = async () => {
    const { code = '' } = getStorageItem()
    const reqInformation: any = {
      applicationCode: code
    }

    setIsLoadingPDF(true)
    await Api.instantGeneratePDF(reqInformation)
      .then((data: { media: { url: string | undefined } }) => {
        setIsLoadingPDF(false)
        console.log('PDF Success', data)

        if (data?.media?.url) {
          const w = window.open(data?.media?.url, '_blank')
          if (w) {
            w.focus()
          }
        } else {
          alert(
            'Unable to get generate PDF link. Kindly confirm your network connection'
          )
        }
      })
      .catch((error: any) => {
        setIsLoadingPDF(false)
        console.log('PDF Error', error)
      })

    // console.log(authResponse)
  }

  const onChangeDraft = (event: { target: { checked: any } }) => {
    if (event.target.checked) {
      setAcceptDraftCheck(true)
    } else {
      setAcceptDraftCheck(false)
    }
  }

  // Fetch paayment provider
  async function rentalPaymentHandler() {
    setLoading(true)
    const { code = '' } = getStorageItem()
    Api.initiatePayment({
      applicationCode: code,
      acceptedContractTerms: acceptDraftCheck,
      needsTour: isTour
    })
      .then((response) => {
        setStorageItem(response)
        navigateTo(7)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        setRentedDialog(error)
        /* Todo */
        //navigateTo(6)
      })
  }

  const goBackToStepFive = () => {
    navigateTo(5)
    setAcceptDraftCheck(false)
    setTour(false)
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const paymentProviders = getStorageItem()?.payment

  const getPaymentStatus = async () => {
    const { code = '' } = getStorageItem()
    await Api.getApplicationByCode(code)
      .then((response) => {
        setPaymentStatus(response)
        setStorageItem(response)
        if (
          response?.payment?.status === 'ok' &&
          response.status === 'tenant'
        ) {
          navigateTo(8)
        }
      })
      .catch((error) => {
        console.log(error.response)
      })
  }

  useEffect(() => {
    if (currentStep === 1) {
      localStorage.removeItem('authinfo')
    }
    if (currentStep === 3) {
      validateApplicantAuthedWithGoodCredit()
    }
    if (currentStep === 7 || currentStep === 8) {
      getPaymentStatus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, movingWithAmount])

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <form onSubmit={handleSubmit(saveInstantRentForm)}>
      <Grid container>
        {' '}
        {currentStep === 1 && (
          <>
            <Grid xs={12} md={8} className={`${classes.marginAuto}`}>
              <InstantRentPrompt
                t={t}
                apartmentCode={apartmentCode}
                classes={classes}
                beforeLogin={beforeLogin}
                navigateTo={navigateTo}
                //doNextStep={updateApartmentInformation}
              />
            </Grid>
          </>
        )}
        {currentStep === 2 && (
          <>
            <Grid container className={classes.formContainer}>
              <Grid xs={12}>
                <Grid container xs={12} md={8} className={classes.marginAuto}>
                  {' '}
                  <Grid item xs={12} className={classes.responsiveWidth}>
                    <Grid item xs={12}>
                      <Typography
                        variant='body1'
                        align='center'
                        className={`${classes.largeText} ${classes.moversTitle} ${classes.boldText}`}
                      >
                        {t('apartment.confirmation.header')}
                      </Typography>
                      <Grid
                        container
                        xs={12}
                        className={classes.datePicker}
                        justify='space-between'
                        // spacing={2}
                      >
                        {/* {' '} */}
                        {/* <DateRangeIcon /> */}
                        <Grid
                          item
                          xs={12}
                          md={4}
                          className={`${classes.calendarInputContainer} ${classes.greyBackground} ${classes.mediumRadius} ${classes.sartDateRow}`}
                        >
                          <>
                            <Typography
                              variant='body2'
                              className={`${classes.labelText} ${classes.boldText}`}
                            >
                              {i18n.t('instantRent.tenancyStartDateLabel')}
                            </Typography>
                            <ReduxFormField
                              fullWidth
                              name='readyForMoveDate'
                              validate={[required, lessThanAvailableUntil]}
                              component={ReduxPicker}
                              label={t('instantRent.tenancyStartDateLabel')}
                              className={`${classes.inlineDatePicker}`}
                              style={{
                                backgroundColor: '#fff',
                                fontSize: '20px'
                              }}
                            />
                          </>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <Suggest
                            containerStyle={classes.containerStyle}
                            suggestContainerStyle={classes.sartDateRow}
                            renderText={() => (
                              <div className={classes.flowView}>
                                <Typography
                                  variant='body2'
                                  className={`${classes.labelText} ${classes.boldText} ${classes.inlineText}`}
                                >
                                  {i18n.t('instantRent.calendarViewPrompt')}
                                </Typography>
                                <Typography
                                  variant='body2'
                                  className={`${classes.labelText} ${classes.inlineText}`}
                                  style={{ whiteSpace: 'pre-line' }}
                                >
                                  {i18n.t('instantRent.calendarViewSuggestion')}
                                </Typography>
                              </div>
                            )}
                            isModal
                            customSuggestTextStyles={`${classes.customSuggestTextStyles} ${classes.centeredText}`}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} className={classes.moversSection}>
                      <Typography
                        variant='body1'
                        align='center'
                        className={`${classes.largeText} ${classes.moversTitle}`}
                      >
                        {t('instantRent.moversTitle')}
                      </Typography>
                      <Grid
                        item
                        xs={12}
                        className={`${classes.moversContainer} ${classes.greyBackground} ${classes.greyBackground}`}
                      >
                        <Typography variant='body1' align='center'>
                          {t('instantRent.moversLabel')}
                        </Typography>
                        <Grid
                          item
                          className={classes.moversField}
                          // style={{ width: '303px' }}
                        >
                          <ReduxFormField
                            name='movingWithAmount'
                            defaultValue={{
                              label: movingWithAmount,
                              value: movingWithAmount
                            }}
                            required
                            validate={[required]}
                            options={[
                              { label: 1, value: 1 },
                              { label: 2, value: 2 },
                              { label: 3, value: 3 },
                              { label: 4, value: 4 },
                              { label: 5, value: 5 },
                              { label: 6, value: 6 }
                            ]}
                            component={ReduxFormSelect}
                            placeholder={t('instantRent.placeholders.movers')}
                            backgroundColor={'#fff'}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#fff',
                              borderRadius: '8px',
                              paddingLeft: '10px'
                            }}
                          />
                        </Grid>
                        {/* <Typography variant='body1' align='center'>
                          {`${t('instantRent.waterBillImplication')} ${
                            moveNumber || 0
                          } ${t('instantRent.peopleLabel')}`}
                        </Typography> */}
                        <Typography variant='body1' align='center'>
                          {t('instantRent.waterBillImplication')}
                          <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            {((movingWithAmount as unknown) as HTMLInputElement | null)
                              ?.value || 0}{' '}
                            {t('instantRent.peopleLabel')}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} className={classes.leaseContainer}>
                      <Typography
                        variant='body1'
                        className={`${classes.largeText} ${classes.leaseDurationTitle}`}
                        align='center'
                      >
                        {t('instantRent.leaseDurationTitle')}
                      </Typography>

                      <Typography variant='body1'>
                        {t('instantRent.leaseDurationBodyParagraph1')}
                        <span style={{ fontWeight: 'bold' }}>
                          {t('instantRent.importantTerminationInfo')}
                        </span>
                      </Typography>
                      <Typography variant='body1'>
                        <pre className='MuiTypography-root MuiTypography-body1'>
                          {t('instantRent.leaseDurationBody', {
                            rentEndDate: '31.12.2022'
                          })}
                        </pre>
                      </Typography>
                    </Grid>
                  </Grid>
                  {isEmpty && (
                    <Typography style={{ color: 'red' }} variant='body1'>
                      {t('apartment.actions.stepFail')}
                    </Typography>
                  )}
                  <Grid container wrap={isMobile ? 'wrap' : 'wrap-reverse'}>
                    {/* <Button
                      fullWidth
                      disableRipple
                      className={`${classes.cancelTextButton}`}
                    >
                      {t('instantRent.buttonLabels.stopRenting')}
                    </Button> */}
                    <Dialog
                      dialogId='UpdateStatusToCancelled'
                      disabled={false}
                      // title={t('apartments.cancel.label')}
                      buttonLabel={t('instantRent.buttonLabels.stopRenting')}
                      buttonFullWidth
                      confirmDialogSubmitAction={() => console.log('confirm1')}
                      buttonClassName={`${classes.cancelTextButton}`}
                      hideCloseIcon
                      className={classes.dialogContanier}
                      borderRadius={'35px'}
                      confirmLabel={t(
                        'instantRent.buttonLabels.continueRenting'
                      )}
                      customButtonContainerDirection={'column-reverse'}
                      customButtonContainerClassName={classes.centeredText}
                      buttonContainerStyles={classes.mb14}
                      customButtonConfirmClassName={classes.modalPrimaryButton}
                      customButtonCloseClassName={classes.modalSecondaryButton}
                      closeLabel={t('instantRent.buttonLabels.stopRenting')}
                      beforeCloseDialogAction={cancelApplication}
                      Content={
                        <TerminationOfTenancyModal classes={classes} t={t} />
                      }
                    />
                    <Grid
                      container
                      justify='space-between'
                      className={classes.buttons}
                    >
                      <Grid item className={classes.buttonGridContainer}>
                        <BackButton
                          currentStep={currentStep}
                          classes={classes}
                          doStepBack={doStepBack}
                          customStyle={classes.shadowSecondaryButton}
                        />
                      </Grid>
                      <Grid item className={classes.buttonGridContainer}>
                        <NextStepButton
                          classes={classes}
                          setIsEmpty={setIsEmpty}
                          disabled={
                            movingWithAmount && readyForMoveDate
                              ? isDisabled
                              : !isDisabled
                          }
                          beforeLogin={beforeLogin}
                          // toValidate={{
                          //   movingWithAmount,
                          //   readyForMoveDate
                          // }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        {currentStep === 3 && (
          <>
            {submitting === true || isLoading === true ? (
              <LoadingContainer />
            ) : (
              <Grid container className={classes.formContainer}>
                <Grid xs={12}>
                  <Grid container xs={12} md={8} className={classes.marginAuto}>
                    {' '}
                    <Grid item xs={12} className={classes.responsiveWidth}>
                      <Grid item xs={12}>
                        <Typography
                          variant='h5'
                          className={`${classes.centeredText} ${classes.heading}`}
                        >
                          {t('instantRent.onlineBankingCredentialsTitle')}
                        </Typography>
                        <Typography
                          variant='body1'
                          className={classes.authDesc}
                        >
                          <pre className='MuiTypography-root MuiTypography-body1'>
                            {t('instantRent.onlineBankingCredentialsDesc')}{' '}
                            <a
                              style={{ color: '#4f9b44' }}
                              href='https://www.fiksuvuokraus.fi/tietosuojaseloste'
                              target='_blank'
                              rel='noreferrer'
                            >
                              {t('instantRent.hereTitle')}
                            </a>
                          </pre>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          style={{ marginRight: '0px', marginLeft: '0px' }}
                          control={
                            <Field
                              inputStyles={classes.checkboxField}
                              name='acceptedTc'
                              component={ReduxCheckbox}
                              disabled={false}
                            />
                          }
                          label={
                            <div>
                              {t(
                                'instantRent.onlineBankingCredentialsCheckboxLabel'
                              )}
                            </div>
                          }
                        />
                      </Grid>
                      {isEmpty && (
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      )}
                      <button
                        style={{
                          background: 'transparent',
                          border: 'none',
                          width: '100%'
                        }}
                        type='submit'
                        disabled={isDisabled}
                      >
                        <StartAuthTrigger
                          suggestContainerStyle={classes.authPrompt}
                          hideSuggestIcon
                          renderText={() => (
                            <Grid
                              container
                              justify='center'
                              alignItems='center'
                              direction={isMobile ? 'column' : 'row'}
                            >
                              <Grid
                                item
                                className={isMobile ? `${classes.mb6}` : ''}
                              >
                                <img src={OutlineLockPersonIcon} />
                              </Grid>
                              <Grid item>
                                <Typography
                                  variant='h6'
                                  className={`${classes.centeredText} ${classes.boldText}`}
                                >
                                  {t('instantRent.startAuthentication')}
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                          isModal
                          customSuggestTextStyles={`${classes.customSuggestTextStyles} ${classes.centeredText}`}
                          doNextStep={saveInstantRentForm}
                          submit
                          setIsEmpty={setIsEmpty}
                          beforeLogin={beforeLogin}
                          toValidate={{
                            acceptedTc
                          }}
                        />
                      </button>
                    </Grid>
                    {/* <CircularProgress color='inherit' /> */}
                    <Grid
                      container
                      direction={isMobile ? 'column' : 'column-reverse'}
                    >
                      <Grid
                        container
                        direction={isMobile ? 'column-reverse' : 'column'}
                        className={classes.buttons}
                        alignItems='center'
                      >
                        <Grid item className={classes.fullWidth}>
                          <BackButton
                            currentStep={currentStep}
                            classes={classes}
                            doStepBack={doStepBack}
                            customStyle={`${classes.shadowSecondaryButton} ${classes.mBottom}`}
                          />
                        </Grid>
                        <Grid item className={classes.fullWidth}>
                          <Dialog
                            dialogId='UpdateStatusToCancelled'
                            disabled={false}
                            buttonLabel={t(
                              'instantRent.buttonLabels.stopRenting'
                            )}
                            buttonFullWidth
                            confirmDialogSubmitAction={() =>
                              console.log('confirm2')
                            }
                            buttonClassName={`${classes.cancelTextButton}`}
                            hideCloseIcon
                            className={classes.dialogContanier}
                            borderRadius={'35px'}
                            confirmLabel={t(
                              'instantRent.buttonLabels.continueRenting'
                            )}
                            customButtonContainerDirection={'column-reverse'}
                            customButtonContainerClassName={
                              classes.centeredText
                            }
                            buttonContainerStyles={classes.mb14}
                            customButtonConfirmClassName={
                              classes.modalPrimaryButton
                            }
                            customButtonCloseClassName={
                              classes.modalSecondaryButton
                            }
                            closeLabel={t(
                              'instantRent.buttonLabels.stopRenting'
                            )}
                            beforeCloseDialogAction={cancelApplication}
                            Content={
                              <TerminationOfTenancyModal
                                classes={classes}
                                t={t}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* suspended rental alert */}
                {authenticationError ===
                  true /* authentication failure alert */ && (
                  <div className={dialogClasses.root}>
                    <ConfirmationDialogRaw
                      maxWidth='sm'
                      classes={{
                        paper: dialogClasses.paper
                      }}
                      keepMounted
                      open={open}
                    >
                      <Box className={classes.authPop}>
                        <Box
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 20
                          }}
                        >
                          <CancelIcon size='5em' color='#D43838' />
                        </Box>
                        <Typography
                          style={{ maxWidth: 300, margin: 'auto' }}
                          align='center'
                          variant='h5'
                        >
                          {t('instantRent.authenticationFailedTitle')}
                        </Typography>
                        <Box
                          style={{
                            paddingTop: 20,
                            paddingBottom: 20
                          }}
                        >
                          <Typography align='center' variant='h6'>
                            {t('instantRent.authenticationFailedDescription')}
                          </Typography>
                        </Box>
                        <Button
                          fullWidth
                          variant='contained'
                          color='primary'
                          className={`${classes.responsiveButton}`}
                          onClick={handleRestartApplication}
                        >
                          <Typography variant='h6'>
                            {t('instantRent.buttonLabels.tryAgain')}
                          </Typography>
                        </Button>
                      </Box>
                    </ConfirmationDialogRaw>
                  </div>
                )}
                {applicantCreditStatus === true && (
                  <div className={dialogClasses.root}>
                    <ConfirmationDialogRaw
                      maxWidth='sm'
                      classes={{
                        paper: dialogClasses.paper
                      }}
                      keepMounted
                      open={open}
                    >
                      <Box className={classes.authPop}>
                        <Box
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 20
                          }}
                        >
                          <CancelIcon size='5em' color='#D43838' />
                        </Box>
                        <Typography
                          style={{ maxWidth: 300, margin: 'auto' }}
                          align='center'
                          variant='h5'
                        >
                          {t('instantRent.rentalSuspendedTitle')}
                        </Typography>
                        <Box
                          style={{
                            paddingTop: 20,
                            paddingBottom: 20
                          }}
                        >
                          <Typography align='center' variant='h6'>
                            {t('instantRent.rentalSuspendedDiscription')}
                          </Typography>
                        </Box>
                        <Button
                          fullWidth
                          variant='contained'
                          color='primary'
                          className={`${classes.responsiveButton}`}
                          onClick={handleRestartApplication}
                        >
                          <Typography variant='h6'>
                            {t('instantRent.buttonLabels.tryAgain')}
                          </Typography>
                        </Button>
                      </Box>
                    </ConfirmationDialogRaw>
                  </div>
                )}
              </Grid>
            )}
          </>
        )}
        {currentStep === 4 && (
          <>
            {isLoading === true ? (
              <LoadingContainer />
            ) : (
              <Grid container className={classes.formContainer}>
                <Grid xs={12}>
                  <Grid container xs={12} md={8} className={classes.marginAuto}>
                    {' '}
                    <Grid item xs={12} className={classes.responsiveWidth}>
                      <Grid item xs={12}>
                        <Typography
                          variant='h5'
                          className={`${classes.heading}`}
                        >
                          {t('instantRent.applicantInfoFormTitle')}
                        </Typography>
                      </Grid>
                      {isEmpty && (
                        <Typography
                          align='center'
                          style={{ color: 'red', paddingTop: 20 }}
                          variant='body1'
                        >
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      )}
                      <Grid
                        container
                        spacing={4}
                        className={classes.containerItem}
                      >
                        <Grid item xs={12} md={6}>
                          <Typography
                            variant='body1'
                            gutterBottom
                            className={`${classes.requiredField} ${classes.formLabel}`}
                          >
                            {t('instantRent.applicant.email')}:
                          </Typography>
                          <ReduxFormField
                            autoComplete='username'
                            name='contactEmail'
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[required, noSpaceValue, validateEmail]}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography
                            variant='body1'
                            gutterBottom
                            className={`${classes.requiredField} ${classes.formLabel}`}
                          >
                            {t('instantRent.applicant.phone')}:
                          </Typography>
                          <ReduxFormField
                            autoComplete='tel'
                            name='phoneNumber'
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[
                              required,
                              noSpacesPhoneNum,
                              validatePhoneNumber
                            ]}
                            required
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        spacing={4}
                        className={classes.containerItem}
                      >
                        <Grid item xs={12} sm={12}>
                          <Typography
                            variant='body1'
                            gutterBottom
                            className={`${classes.requiredField} ${classes.formLabel}`}
                          >
                            {t('instantRent.applicant.address')}:
                          </Typography>

                          <ReduxFormField
                            name='autocompleteLocation'
                            // normalize={charsSpace}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[requiredLocation, isInvalidCharacters]}
                            required
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        spacing={4}
                        className={classes.containerItem}
                      >
                        <Grid item xs={12} md={6}>
                          <Typography
                            variant='body1'
                            gutterBottom
                            className={`${classes.requiredField} ${classes.formLabel}`}
                          >
                            {t('instantRent.applicant.postalCode')}:
                          </Typography>
                          <ReduxFormField
                            name='postalCode'
                            normalize={onlyNums}
                            min={0}
                            validate={[
                              required,
                              isPostalCode,
                              isInvalidCharacters
                            ]}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography
                            variant='body1'
                            gutterBottom
                            className={`${classes.requiredField} ${classes.formLabel}`}
                          >
                            {t('instantRent.applicant.place')}:
                          </Typography>

                          <ReduxFormField
                            name='postalArea'
                            normalize={charsSpace}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[requiredLocation, isInvalidCharacters]}
                            required
                          />
                        </Grid>
                      </Grid>

                      <Suggest
                        suggestContainerStyle={classes.applicantInfo}
                        hideSuggestIcon
                        renderText={() => (
                          <Grid
                            container
                            justify='center'
                            alignItems='center'
                            direction={isMobile ? 'column' : 'row'}
                          >
                            <Grid item xs={10}>
                              <Typography
                                variant='body1'
                                className={classes.labelText}
                              >
                                {t('instantRent.applicant.info')}
                              </Typography>
                            </Grid>
                            <Grid
                              className={classes.containerItem}
                              item
                              xs={10}
                            >
                              <a
                                href='https://fiksuvuokraus.fi/tietosuojaseloste/'
                                target='_blank'
                                rel='noreferrer'
                                className={classes.privacyStatementLink}
                              >
                                {t('instantRent.privacyStatement')} &gt;
                              </a>
                            </Grid>

                            <Grid
                              item
                              xs={10}
                              className={classes.containerItem}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color='primary'
                                    // onChange={onChangeCheckBox}
                                  />
                                }
                                label={
                                  <div className={classes.labelText}>
                                    {t('instantRent.offersConsent')}
                                  </div>
                                }
                              />
                            </Grid>
                          </Grid>
                        )}
                        isModal
                        customSuggestTextStyles={`${classes.customSuggestTextStyles} ${classes.centeredText}`}
                      />
                    </Grid>
                    <Grid
                      container
                      direction={isMobile ? 'column' : 'column-reverse'}
                    >
                      <Grid
                        container
                        direction={isMobile ? 'column-reverse' : 'column'}
                        className={classes.buttons}
                        alignItems='center'
                      >
                        <Grid item className={classes.fullWidth}>
                          {/* <NextStepButton
                          customStyles={classes.primaryBtn}
                          classes={classes}
                          beforeLogin={beforeLogin}
                          setIsEmpty={setIsEmpty}
                        /> */}
                          {/* <NextStepButton
                            classes={classes}
                            setIsEmpty={setIsEmpty}
                            disabled={isDisabled}
                            beforeLogin={beforeLogin}
                            toValidate={{
                              contactEmail,
                              phoneNumber,
                              autocompleteLocation,
                              postalCode,
                              postalArea
                            }}
                          /> */}
                          <Button
                            // disabled={isChecked}
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={`${classes.responsiveButton}`}
                            onClick={handleFormEvent}
                          >
                            <Grid
                              container
                              justify='center'
                              alignItems='center'
                            >
                              <Grid item>{t('general.next')}</Grid>
                              <Grid item className={classes.rightFloatingIcon}>
                                <ChevronRightIcon color='#D8DCDF' />
                              </Grid>
                            </Grid>
                          </Button>
                        </Grid>
                        <Grid item className={classes.fullWidth}>
                          <Dialog
                            dialogId='UpdateStatusToCancelled'
                            disabled={false}
                            buttonLabel={t(
                              'instantRent.buttonLabels.stopRenting'
                            )}
                            buttonFullWidth
                            confirmDialogSubmitAction={() =>
                              console.log('confirm3')
                            }
                            buttonClassName={`${classes.cancelTextButton}`}
                            hideCloseIcon
                            className={classes.dialogContanier}
                            borderRadius={'35px'}
                            confirmLabel={t(
                              'instantRent.buttonLabels.continueRenting'
                            )}
                            customButtonContainerDirection={'column-reverse'}
                            customButtonContainerClassName={
                              classes.centeredText
                            }
                            buttonContainerStyles={classes.mb14}
                            customButtonConfirmClassName={
                              classes.modalPrimaryButton
                            }
                            customButtonCloseClassName={
                              classes.modalSecondaryButton
                            }
                            closeLabel={t(
                              'instantRent.buttonLabels.stopRenting'
                            )}
                            beforeCloseDialogAction={cancelApplication}
                            Content={
                              <TerminationOfTenancyModal
                                classes={classes}
                                t={t}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  {newRentDialog !== null ? (
                    <>
                      <div className={dialogClasses.root}>
                        <ConfirmationDialogRaw
                          maxWidth='sm'
                          classes={{
                            paper: dialogClasses.paper
                          }}
                          keepMounted
                          open={open}
                        >
                          <Box className={classes.addNewTenantStyles}>
                            <Typography
                              style={{ maxWidth: 300, margin: 'auto' }}
                              align='center'
                              variant='h5'
                            >
                              {t('instantRent.doYouWantToAdd')}
                            </Typography>
                            <Box
                              className={classes.addNewTenantDetailsStyle}
                              mt={4}
                              mb={4}
                            >
                              <img
                                src={suggestIcon}
                                className={classes.suggestIcon}
                                alt={'Suggest Icon'}
                              />
                              {/* <BulbOutlineIcon size='3em' color='#FFBA57' /> */}
                              <Typography
                                style={{ paddingLeft: 20 }}
                                align='left'
                                variant='body1'
                              >
                                {t('instantRent.addLease')}
                              </Typography>
                            </Box>
                            <Button
                              fullWidth
                              color='primary'
                              variant='contained'
                              className={`${classes.responsiveButton}`}
                              onClick={() => navigateTo(5)}
                            >
                              <Typography variant='h6'>
                                {t('instantRent.proceedToNextStep')}
                              </Typography>
                            </Button>
                            <Button
                              fullWidth
                              color='primary'
                              className={`${classes.responsiveButton}`}
                              style={{
                                boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)'
                              }}
                              onClick={addNewTenant}
                            >
                              <Typography variant='h6'>
                                {t('instantRent.addNewApplicant')}
                              </Typography>
                            </Button>
                          </Box>
                        </ConfirmationDialogRaw>
                      </div>
                    </>
                  ) : null}
                </Grid>
              </Grid>
            )}
          </>
        )}
        {currentStep === 5 && (
          <>
            <Grid container className={classes.formContainer}>
              <Grid xs={12}>
                {isLoadingPDF ? (
                  <LoadingContainer />
                ) : (
                  <Grid container xs={12} md={8} className={classes.marginAuto}>
                    {' '}
                    <Grid
                      item
                      xs={12}
                      className={`${classes.responsiveWidth} ${classes.centeredText}`}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant='h4'
                          className={`${classes.centeredText} ${
                            classes.heading
                          } ${isMobile ? classes.my6 : classes.my8}`}
                        >
                          {t('instantRent.draftAggrement')}
                        </Typography>
                        <Box
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          mb={4}
                        >
                          <Grid
                            item
                            className={isMobile ? `${classes.mb6}` : ''}
                          >
                            <img src={WarningIcon} />
                          </Grid>
                          <Typography
                            style={{ paddingLeft: 15 }}
                            variant='body1'
                          >
                            {t('instantRent.checkDetails')}
                          </Typography>
                        </Box>
                        <Typography align='left' variant='body1'>
                          {t('instantRent.noticeError')}
                        </Typography>
                        <Box>
                          <button
                            type='button'
                            onClick={() => generateTenantPDF()}
                            style={{
                              width: '100%',
                              borderRadius: 20,
                              background: '#FBF6EE',
                              border: 0,
                              marginTop: 40,
                              marginBottom: 40,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              cursor: 'pointer'
                            }}
                          >
                            <Grid
                              item
                              className={isMobile ? `${classes.mb6}` : ''}
                            >
                              <img src={DownloadIcon} />
                            </Grid>
                            <Typography
                              style={{ paddingLeft: 15, fontWeight: 612 }}
                              variant='h6'
                              className={`${classes.centeredText} ${
                                classes.heading
                              } ${isMobile ? classes.my6 : classes.my8}`}
                            >
                              {t('instantRent.downloadLease')}
                            </Typography>
                          </button>
                        </Box>
                        <Typography
                          variant='h6'
                          align='left'
                          className={`${classes.boldText} ${
                            isMobile ? classes.my6 : classes.my8
                          }`}
                        >
                          {t('instantRent.satisfactionGuarantee')}
                        </Typography>{' '}
                        <Typography align='left' variant='body1'>
                          {t('instantRent.satisfactionDetails')}
                        </Typography>
                        <Typography
                          variant='h6'
                          align='left'
                          color='primary'
                          className={`${classes.boldText} ${
                            isMobile ? classes.my6 : classes.my8
                          }`}
                        >
                          {t('instantRent.satisfactionGuaranteeMore')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid>
                      <FormControlLabel
                        className={`${classes.labelChecker}`}
                        control={
                          <Checkbox
                            onChange={(event) => setTour(event.target.checked)}
                            color='primary'
                            // onChange={onChangeCheckBox}
                          />
                        }
                        label={
                          <div
                            style={{
                              textAlign: 'left',
                              paddingLeft: 10
                            }}
                            className={classes.labelText}
                          >
                            <Trans i18nKey='instantRent.noTour'>
                              <b></b>
                            </Trans>
                          </div>
                        }
                      />
                      <FormControlLabel
                        className={`${classes.labelChecker}`}
                        control={
                          <Checkbox color='primary' onChange={onChangeDraft} />
                        }
                        label={
                          <div
                            style={{
                              textAlign: 'left',
                              paddingLeft: 10
                            }}
                            className={classes.labelText}
                          >
                            {t('instantRent.acceptDraft')}
                          </div>
                        }
                      />
                    </Grid>
                    <Grid container wrap={isMobile ? 'wrap' : 'wrap-reverse'}>
                      <Dialog
                        dialogId='UpdateStatusToCancelled'
                        disabled={false}
                        buttonLabel={t('instantRent.buttonLabels.stopRenting')}
                        buttonFullWidth
                        confirmDialogSubmitAction={() =>
                          console.log('confirm4')
                        }
                        buttonClassName={`${classes.cancelTextButton}`}
                        hideCloseIcon
                        className={classes.dialogContanier}
                        borderRadius={'35px'}
                        confirmLabel={t(
                          'instantRent.buttonLabels.continueRenting'
                        )}
                        customButtonContainerDirection={'column-reverse'}
                        customButtonContainerClassName={classes.centeredText}
                        buttonContainerStyles={classes.mb14}
                        customButtonConfirmClassName={
                          classes.modalPrimaryButton
                        }
                        customButtonCloseClassName={
                          classes.modalSecondaryButton
                        }
                        closeLabel={t('instantRent.buttonLabels.stopRenting')}
                        beforeCloseDialogAction={cancelApplication}
                        Content={
                          <TerminationOfTenancyModal classes={classes} t={t} />
                        }
                      />
                      <Grid
                        container
                        justify='space-between'
                        className={classes.buttons}
                      >
                        <Grid
                          item
                          className={`${classes.buttonGridContainer} ${classes.shadowSecondaryButton}`}
                        >
                          <BackButton
                            currentStep={currentStep}
                            classes={classes}
                            doStepBack={doStepBack}
                          />
                        </Grid>
                        <Grid item className={classes.buttonGridContainer}>
                          <NextStepButton
                            disabled={!acceptDraftCheck}
                            classes={classes}
                            setIsEmpty={setIsEmpty}
                            beforeLogin={beforeLogin}
                          />
                          {/* <Button
                          disabled={acceptDraftCheck}
                          fullWidth
                          variant='contained'
                          color='primary'
                          className={`${classes.responsiveButton}`}
                          // onClick={rentalPaymentHandler}
                        >
                          <Grid container justify='center' alignItems='center'>
                            <Grid item>{t('general.next')}</Grid>
                            <Grid item className={classes.rightFloatingIcon}>
                              <ChevronRightIcon color='#D8DCDF' />
                            </Grid>
                          </Grid>
                        </Button> */}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid>
                      <Typography
                        variant='h6'
                        className={`${classes.boldText}
                        ${classes.paragraphStyle}
                        ${isMobile ? classes.my6 : classes.my8}`}
                        style={{ marginTop: '20px' }}
                      >
                        {t('instantRent.aggreementNote')}{' '}
                        <span>{t('instantRent.aggreementNoteSuccess')}</span>
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </>
        )}
        {currentStep === 6 && (
          <>
            {isLoading === true ? (
              <LoadingContainer />
            ) : (
              <Grid container className={classes.formContainer}>
                <Grid xs={12}>
                  <Grid container xs={12} md={8} className={classes.marginAuto}>
                    {' '}
                    <Grid item className={classes.centeredText} xs={12}>
                      <img
                        src={RentalDepositAsset}
                        style={{ objectFit: 'contain' }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={`${classes.responsiveWidth} ${classes.centeredText}`}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant='h5'
                          className={`${classes.centeredText} ${
                            classes.heading
                          } ${isMobile ? classes.my6 : classes.my8}`}
                        >
                          {t('instantRent.depositPaymentTitle')}
                        </Typography>
                        <Typography variant='body1'>
                          {t('instantRent.depositPaymentDescription')}
                        </Typography>
                        <Typography
                          variant='body1'
                          className={`${classes.boldText} ${
                            isMobile ? classes.my6 : classes.my8
                          }`}
                        >
                          {t('instantRent.depositPaymentCallout')}
                        </Typography>{' '}
                        <Typography variant='body1'>
                          {t('instantRent.depositPaymentNote')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container wrap={isMobile ? 'wrap' : 'wrap-reverse'}>
                      <Dialog
                        dialogId='UpdateStatusToCancelled'
                        disabled={false}
                        // title={t('apartments.cancel.label')}
                        buttonLabel={t('instantRent.buttonLabels.stopRenting')}
                        buttonFullWidth
                        confirmDialogSubmitAction={() =>
                          console.log('confirm5')
                        }
                        buttonClassName={`${classes.cancelTextButton}`}
                        hideCloseIcon
                        className={classes.dialogContanier}
                        borderRadius={'35px'}
                        confirmLabel={t(
                          'instantRent.buttonLabels.continueRenting'
                        )}
                        customButtonContainerDirection={'column-reverse'}
                        customButtonContainerClassName={classes.centeredText}
                        buttonContainerStyles={classes.mb14}
                        customButtonConfirmClassName={
                          classes.modalPrimaryButton
                        }
                        customButtonCloseClassName={
                          classes.modalSecondaryButton
                        }
                        closeLabel={t('instantRent.buttonLabels.stopRenting')}
                        beforeCloseDialogAction={cancelApplication}
                        Content={
                          <TerminationOfTenancyModal classes={classes} t={t} />
                        }
                      />
                      <Grid
                        container
                        justify='space-between'
                        className={classes.buttons}
                      >
                        <Grid
                          item
                          className={`${classes.buttonGridContainer} ${classes.shadowSecondaryButton}`}
                        >
                          <Button
                            onClick={goBackToStepFive}
                            style={{ color: '#2F2F2F' }}
                            fullWidth
                            disableRipple
                            className={`${classes.responsiveButton} ${classes.customStyle}`}
                          >
                            {t('general.back')}
                          </Button>
                        </Grid>
                        <Grid item className={classes.buttonGridContainer}>
                          <Button
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={`${classes.responsiveButton}`}
                            onClick={rentalPaymentHandler}
                          >
                            <Grid
                              container
                              justify='center'
                              alignItems='center'
                            >
                              <Grid item>{t('general.next')}</Grid>
                              <Grid item className={classes.rightFloatingIcon}>
                                <ChevronRightIcon color='#D8DCDF' />
                              </Grid>
                            </Grid>
                          </Button>
                        </Grid>
                      </Grid>
                      {rentedDialog?.name === 'Error' && (
                        <>
                          <div className={dialogClasses.root}>
                            <ConfirmationDialogRaw
                              maxWidth='sm'
                              classes={{
                                paper: dialogClasses.paper
                              }}
                              keepMounted
                              open={failedPaymentModal}
                            >
                              <Box pt={8} pb={8} pl={8} pr={8}>
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexDirection: 'column'
                                  }}
                                  mt={4}
                                  mb={4}
                                >
                                  <CancelIcon size='5em' color='#D43838' />
                                  <Typography
                                    style={{
                                      paddingTop: 20,
                                      paddingBottom: 15
                                    }}
                                    align='center'
                                    variant='h4'
                                  >
                                    {t('instantRent.applicationRentedTitle')}
                                  </Typography>
                                  <Typography
                                    style={{ paddingLeft: 20, maxWidth: 350 }}
                                    align='center'
                                    variant='body1'
                                  >
                                    {t(
                                      'instantRent.applicationRentedDescription'
                                    )}
                                  </Typography>
                                </Box>
                                <Button
                                  fullWidth
                                  color='secondary'
                                  className={`${classes.responsiveButton}`}
                                  style={{
                                    boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)'
                                  }}
                                  onClick={cancelApplication}
                                >
                                  <Typography variant='h6'>
                                    {t('instantRent.ok')}
                                  </Typography>
                                </Button>
                              </Box>
                            </ConfirmationDialogRaw>
                          </div>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </>
        )}
        {currentStep === 7 && (
          <>
            <Grid container className={classes.formContainer}>
              <Grid xs={12}>
                {
                  <Grid container className={classes.marginAuto}>
                    {' '}
                    {isLoading === true ? (
                      <LoadingContainer />
                    ) : (
                      <Grid container xs={12}>
                        <Grid item xs={12}>
                          <Typography
                            variant='h4'
                            className={`${classes.centeredText} ${
                              classes.heading
                            } ${isMobile ? classes.my6 : classes.my8}`}
                          >
                            {t('instantRent.onlineBanking')}
                          </Typography>
                        </Grid>
                        <div className={classes.paymentOption}>
                          {paymentProviders !== undefined ? (
                            <>
                              {paymentProviders.providers.map(
                                (provider: any) => (
                                  <form
                                    method='POST'
                                    action={provider.url}
                                    key={provider.id}
                                    className={classes.paymentCard}
                                    onSubmit={(event) => {
                                      event.preventDefault()
                                      event.currentTarget.submit()
                                    }}
                                  >
                                    {provider.parameters.map(
                                      (param: {
                                        name: string | undefined
                                        value:
                                          | string
                                          | number
                                          | readonly string[]
                                          | undefined
                                      }) => (
                                        <input
                                          key={param.name}
                                          type='hidden'
                                          name={param.name}
                                          value={param.value}
                                        />
                                      )
                                    )}
                                    <button
                                      style={{
                                        width: '200px',
                                        height: '113px',
                                        border: '2px solid #BFC4CA',
                                        borderRadius: '27px',
                                        marginLeft: '10px',
                                        marginRight: '10px',
                                        marginBottom: '20px',
                                        background: 'transparent',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      <img
                                        style={{
                                          objectFit: 'contain',
                                          width: '80%'
                                        }}
                                        src={provider.svg}
                                        alt={provider.value}
                                      />
                                    </button>
                                  </form>
                                )
                              )}
                            </>
                          ) : (
                            <Grid item xs={12}>
                              <Typography
                                variant='h5'
                                className={`${classes.centeredText} ${
                                  classes.heading
                                } ${isMobile ? classes.my6 : classes.my8}`}
                              >
                                {t('general.notAvailable')}
                              </Typography>
                            </Grid>
                          )}
                        </div>
                      </Grid>
                    )}
                    {isPaymentStatus?.payment.status === 'fail' && (
                      <div className={dialogClasses.root}>
                        <ConfirmationDialogRaw
                          maxWidth='sm'
                          classes={{
                            paper: dialogClasses.paper
                          }}
                          keepMounted
                          open={failedPaymentModal}
                        >
                          <Box pt={8} pb={8} pl={8} pr={8}>
                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column'
                              }}
                              mt={4}
                              mb={4}
                            >
                              <CancelIcon size='5em' color='#D43838' />
                              <Typography
                                style={{ paddingTop: 20, paddingBottom: 15 }}
                                align='center'
                                variant='h4'
                              >
                                {t('instantRent.paymentFailedTitle')}
                              </Typography>
                              <Typography
                                style={{ paddingLeft: 20, maxWidth: 350 }}
                                align='center'
                                variant='body1'
                              >
                                {t('instantRent.paymentFailedDescription')}
                              </Typography>
                            </Box>
                            <Button
                              fullWidth
                              variant='contained'
                              color='primary'
                              className={`${classes.responsiveButton}`}
                              onClick={tryAgainHandler}
                            >
                              <Typography variant='h6'>
                                {t('instantRent.buttonLabels.tryAgain')}
                              </Typography>
                            </Button>
                            <Button
                              fullWidth
                              color='secondary'
                              className={`${classes.responsiveButton}`}
                              onClick={cancelApplication}
                            >
                              <Typography variant='h6'>
                                {t('instantRent.buttonLabels.stopRenting')}
                              </Typography>
                            </Button>
                          </Box>
                        </ConfirmationDialogRaw>
                      </div>
                    )}
                  </Grid>
                }
              </Grid>
            </Grid>
          </>
        )}
        {currentStep === 8 && (
          <>
            <Grid container className={classes.formContainer}>
              <Grid xs={12}>
                <Grid container xs={12} md={8} className={classes.marginAuto}>
                  <InstantRentCompletePage
                    classes={classes}
                    t={t}
                    apartment={getStorageItem('apartment')}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </form>
  )
}

const selector = formValueSelector('InstantRentForm')

const mapStateToProps = (state: StateInterface) => ({
  readyForMoveDate: selector(state, 'readyForMoveDate'),
  movingWithAmount: selector(state, 'movingWithAmount'),
  acceptedTc: selector(state, 'acceptedTc'),
  contactEmail: selector(state, 'contactEmail'),
  phoneNumber: selector(state, 'phoneNumber'),
  autocompleteLocation: selector(state, 'autocompleteLocation'),
  postalCode: selector(state, 'postalCode'),
  postalArea: selector(state, 'postalArea')
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  changeFormValue: (field: string, value: string) =>
    dispatch(change('InstantRentForm', field, value)),
  doNextStep: (beforeLogin: boolean) =>
    dispatch(stepInstantRentForward({ beforeLogin }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'InstantRentForm'
  })(
    withStyles(styles)(withTranslation()(InstantRentForm as any)) as any
  ) as any
) as any
